import { render, staticRenderFns } from "./PluginsPane.vue?vue&type=template&id=66ada736&scoped=true&"
import script from "./PluginsPane.vue?vue&type=script&lang=js&"
export * from "./PluginsPane.vue?vue&type=script&lang=js&"
import style0 from "./PluginsPane.vue?vue&type=style&index=0&id=66ada736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ada736",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VForm,VIcon,VList,VListItem,VListItemGroup})
